import React from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../Paginations';

const AvailableTracksTab = ({ 
  filteredTracks, 
  currentItems, 
  currentPage, 
  totalPages, 
  handlePageChange, 
  handleSearch, 
  setIsrc, 
  setTitle 
}) => {
  if (filteredTracks.length === 0) {
    return (
      <div className="text-center py-5">
        <h5>No tracks found</h5>
        <p>You don't have any tracks available for splits</p>
      </div>
    );
  }

  return (
    <>
      <input 
        type="text" 
        className='dash-input' 
        onChange={handleSearch} 
        placeholder='Search...' 
      />
      <div className="table-responsive mt-3">
        <table className="table dash-table">
          <thead>
            <tr>
              <td>Title</td>
              <td>ISRC</td>
              <td>Genre</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((track, i) => (
              <tr key={i}>
                <td>
                  <div className="table-item">
                    {track.title}
                  </div>
                </td>
                <td>
                  <div className="table-item">
                    {track.isrc}
                  </div>
                </td>
                <td>
                  <div className="table-item">
                    {track.genre}
                  </div>
                </td>
                <td>
                  <div className="table-item">
                    <Link 
                      to={'#'} 
                      onClick={() => { 
                        setIsrc(track.isrc); 
                        setTitle(track.title); 
                      }} 
                      data-bs-toggle="modal" 
                      data-bs-target="#addShareModal"
                    >
                      <i className="fi fi-rr-eye table-action-btn a-blue"></i>
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        handlePageChange={handlePageChange} 
      />
    </>
  );
};

export default AvailableTracksTab; 